import React from 'react'

import Placeholder from 'components/Form/Placeholder/Placeholder'

import Pagination from '../../Pagination/Pagination'

import './DataGrid.scss'

const DataGrid = ({ columns, pagination, isLoading, emptyText, onPageChange, isHidePagination = false }) => {
    const getValue = (column, row, columnIndex, rowIndex) =>
        column.getValue
            ? column.getValue(column.field ? row[column.field] : row, columnIndex, rowIndex)
            : row[column.field]
    const getTitle = (column, row, columnIndex, rowIndex) =>
        column.getTitle
            ? column.getTitle(column.field ? row[column.field] : row, columnIndex, rowIndex)
            : row[column.field]

    return (
        <div className="data-grid">
            {!pagination.content.length ? (
                <Placeholder title={emptyText} />
            ) : (
                <>
                    <ul className="data-grid__header">
                        {columns.map((column, columnIndex) => (
                            <li className="data-grid__header__column" key={columnIndex} style={column.styles}>
                                {column.headerName}
                            </li>
                        ))}
                    </ul>
                    {pagination.content.map((row, rowIndex) => (
                        <ul key={rowIndex} className="data-grid__content">
                            {columns.map((column, columnIndex) => (
                                <li
                                    key={columnIndex}
                                    className="data-grid__content__column"
                                    style={column.styles}
                                    title={getTitle(column, row, columnIndex, rowIndex)}
                                >
                                    {getValue(column, row, columnIndex, rowIndex)}
                                </li>
                            ))}
                        </ul>
                    ))}
                </>
            )}

            {!isHidePagination && (
                <Pagination
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    currentPage={pagination.pageable.pageNumber}
                    totalPages={pagination.totalPages}
                    isLoading={isLoading}
                    onChange={page => {
                        onPageChange(page)
                    }}
                />
            )}
        </div>
    )
}

export default DataGrid
